
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

declare const FB: any;

@Injectable()

export class EvsUserService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
        this.setEndPoint('');
        FB.init({
            appId: '897109161135769',
            status: false, // the SDK will attempt to get info about the current user immediately after init
            cookie: false,  // enable cookies to allow the server to access
            // the session
            xfbml: false,  // With xfbml set to true, the SDK will parse your page's DOM to find and initialize any social plugins that have been added using XFBML
            version: 'v16.0' // use graph api version 2.5
        });
    }

    listOwner() {
        return this.get("/owner");
    }
    acceptInvitation(id: any) {
        return this.get('/owner/accept/' + id);
    }
    loginByOwner(id: any) {
        return this.post('/owner/' + id + '/login');
    }
    leaveOwner(id: any) {
        return this.get('/owner/leave/' + id);
    }

    getListStaff(data?: any) {
        return this.get("/staffs", data);
    }
    createStaff(data?: any) {
        return this.post('/create-account', data);
    }
    getPermissions(id?: any) {
        return this.get('/permissions?user_id=' + id);
        // return this.get('/permissions');
    }
    setPermission(id, data: any) {
        return this.post('/add-permission/' + id, data);
        // return this.get('/permissions');
    }
    reset_password(uid: any, data: any) {
        return this.post('/reset-password/' + uid, data);
    }
    delete_account(uid: any) {
        return this.delete('/staff/' + uid);
    }
    undeleted_staff(uid: any) {
        return this.put('/staff/undelete/' + uid);
    }

    actionKickStaff(id: any) {
        return this.get('/staff/kick/' + id);
    }
    actionInviteStaff(icheck_id: any) {
        return this.get('/staff/invite/' + icheck_id);
    }

    getListRole() {
        return this.get('/roles');
    }
    setRoleStaff(data: any) {
        return this.post('/staff/role', data)
    }

    searchStaff(data: any) {
        return this.get('/users/detail', data);
    }

    find(id) {
        return this.get('/staffs/' + id);
    }

    changeAvaiable(id: any, data: any) {
        return this.post('/change-avaiable/' + id, data);
    }


    fbLogin() {
        return new Promise((resolve, reject) => {
            FB.login(result => {
                if (result.authResponse) {
                    console.log('fb', result);
                    // FB.api("/"+result.authResponse.userID+"/permissions",  function(res) {
                    FB.api("/me/accounts",  function(res) {
                        console.log(res);
                    })
                    // return this.get(`/auth/pages`, { access_token: result.authResponse.accessToken })
                    //     .toPromise()
                    //     .then(response => {
                    //         var token = response.headers.get('x-auth-token');
                    //         if (token) {
                    //             localStorage.setItem('id_token', token);
                    //         }
                    //         resolve(response.json());
                    //     })
                    //     .catch(() => reject());
                } else {
                    reject();
                }
            }, { config_id: '6067491543327743' })
        });
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/EvsUser.service.ts